<template>
  <div v-loading.fullscreen="loading" element-loading-text="" element-loading-spinner="el-icon-loading">
      <!--  SEARCH RESULTS -->
      <!-- <b-container> -->
        <div class="embed-container" id="results">
          <md-toolbar class="mt-3" md-elevation="1">
            <div class="md-toolbar-row">
              <div class="md-toolbar-section-start">
                <h3 class="md-title" style="flex:1" id="result-title">PROPERTIES</h3>
              </div>
              <div class="md-toolbar-section-end">
                <md-field class="sort-menu">
                  <label for="movie">Sort</label>
                  <md-select v-model="selectedSort" name="sort" id="sort" @md-selected="startSortListings">
                    <md-option value="none">None</md-option>
                    <md-option value="price-hf">Price: Highest first</md-option>
                    <md-option value="price-lf">Price: Lowest first</md-option>
                    <md-option value="date-hf">Date: Latest first</md-option>
                    <md-option value="date-lf">Date: Oldest first</md-option>
                    <md-option value="rooms-hf">Bedrooms: Highest first</md-option>
                    <md-option value="rooms-lf">Bedrooms: Lowest first</md-option>
                  </md-select>
                </md-field>
                <md-button @click="switchToListView" class="mo-btn-list"></md-button>
                <md-button @click="switchToGridView" class="md-primary mo-btn-grid"></md-button>
              </div>
            </div>
            <div v-if="showFilterTags" class="md-toolbar-row">
              <md-button @click="clearFilterAndSearch" class="mo-text-blue">Clear</md-button>
              <md-chips md-static v-model="filterTags" class="mo-chips"></md-chips>
            </div>
          </md-toolbar>
          <b-row class="mt-2">
            <div v-if="loadingListings" class="loader-rolling-local mt-5" style="margin: 0 auto;"></div>
            <b-col v-else>
              <div v-for="(data,id) in sortedListings" :key="id"  style="display:contents">

                <b-row v-if="inListView" lg="9" md="10" sm="12" class="dash-element-container-clickable mt-3">
                  <!--  LIST VIEW -->
                  <b-col lg="3" md="4" sm="6" class="dash-element-image hover-listener">
                      <!-- <b-img fluid rounded :id="id" :src="data.genDet.thumbUrls.length!=0?data.genDet.thumbUrls[0]:placeholder" alt="Thumbnail" /> -->
                      <b-img fluid rounded :id="id" :src="getListingCoverThumbnail(data)" alt="Thumbnail" />
                      <div class="hover-buttons-container limited" :class="{hide:data.genDet.thumbUrls.length==0}">
                        <div class="mo-btn-next small limit" v-on:click="nextPreviewImg($event, {thumbUrls:data.genDet.thumbUrls, id:id})"></div>
                        <div class="mo-btn-prev small" v-on:click="prevPreviewImg($event, {thumbUrls:data.genDet.thumbUrls, id:id})"></div>
                      </div>
                  </b-col>
                  <b-col lg="8" md="8" sm="8" @click="navigateToListings($event, data.maaklerID)">
                    <b-row>
                      <b-col>
                        <b-row>
                          <span class="mo-card-title">{{data.marketingDet.shortDesc}}</span>
                        </b-row>
                        <b-row class="mt-2">
                          <span class="dash-item-subtitle">{{data.location.address.municipality}}, {{data.location.address.street}} {{data.location.address.number}}</span>
                        </b-row>
                        <b-row class="mt-2" style="line-height:2em">
                          <b-img style="margin-right: 1em;width:26px;height:26px" src="../assets/Doublebed.svg"></b-img>
                          <span>{{data.techDet.nrOfBedrooms}}</span>

                        </b-row>
                        <b-row class="mt-2">
                          <span class="listing-rooms">For {{getTxnDisplayType(data.txnDet.txnType)}}</span>
                        </b-row>
                        <b-row>
                          <p class="mo-card-title" style="margin-right:5px;">{{data.txnDet.price}}</p><p>{{getCurrencySign(data.txnDet.currency)}} {{getTxnPeriodType(data.txnDet.txnType)}}</p>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

              <!--  GRID  -->
              <!-- <md-card v-else class="mo-listing-card"  lg="4" md="4" sm="4" v-for="(data,id) in filteredListings" :key="id" @click="navigateToListings($event, data.maaklerID)"> -->
                <md-card v-else class="mo-listing-card">
                  <md-card-area>

                    <md-card-media class="hover-listener">
                      <img :id="id" :src="getListingCoverImage(data)" alt="Thumbnail"/>
                    </md-card-media>

                    <md-card-header>
                      <div class="md-title">{{data.marketingDet.shortDesc}}</div>
                      <div class="md-subhead">{{data.location.address.municipality}}, {{data.location.address.street}} {{data.location.address.number}}</div>
                    </md-card-header>

                    <md-card-content>
                      <b-row class="mt-2">
                        <b-col>
                          <b-row>
                            <b-col>
                              <b-img style="width:26px;height:26px" src="../assets/Doublebed.svg"></b-img>
                            </b-col>
                            <b-col style="line-height:2em;">
                              <span class="align-middle">
                                {{data.techDet.nrOfBedrooms}}
                              </span>
                            </b-col>
                          </b-row>
                          <b-row class="mt-2">
                            <md-button @click="navigateToListings($event, data.maaklerID)" style="margin:0 auto" class="mo-btn-primary-outlined">See Listing</md-button>
                          </b-row>
                          <!-- <b-row>
                            <b-col><md-chips v-model="getTagwords(tagwords)" md-static></md-chips></b-col>
                          </b-row> -->
                        </b-col>
                        <!-- <b-col lg="4" md="4" sm="4">
                          <b-img style="width:26px;height:26px" src="../assets/Doublebed.svg"></b-img>
                          <p style="line-height:26px">{{data.techDet.nrOfBedrooms}}</p>
                        </b-col> -->
                        <b-col lg="8" md="8" sm="8" style="text-align: right">
                          <span class="listing-rooms">For {{getTxnDisplayType(data.txnDet.txnType)}}</span><br>
                          <span class="mo-card-title" style="margin-right:5px;">{{data.txnDet.price}}</span><p>{{getCurrencySign(data.txnDet.currency)}} {{getTxnPeriodType(data.txnDet.txnType)}}</p>
                        </b-col>
                      </b-row>

                    </md-card-content>
                  </md-card-area>
                </md-card>
              </div>
              <b-row style="padding:2em">
                <a href="https://app.moowle.com" target="_blank"><md-button style="margin:0 auto">LOAD MORE</md-button></a>
              </b-row>
            </b-col>
          </b-row>
        </div>
      <!-- </b-container> -->
  </div>

</template>

<script>
  import {
    Validator
  } from 'vee-validate'
  import {
    getFilteredMaaklerListingsLite,
    getMaaklerListingsLiteOlderThen,
    getListingCoverThumbnail,
    getListingCoverImage
  } from '../listingsRepository.js'
  import {
    checkForLoginOrGoAnonymous
  } from '../users/repositories/userRepository.js'
  import {
    getPlacePredictions,
  } from '../mapsRepository.js'
  export default {
    name: 'embedmarket',
    validator: null,
    data() {
      return {
        loading: false,
        placesPredictions: [],
        selectedPlace: '',
        filterMuni: undefined,
        filterPriceFrom: undefined,
        filterPriceTo: undefined,
        filterBedroomsMin: undefined,
        filterBedroomsMax: undefined,
        loadingListings: false,
        filteredListings: [],
        sortedListings: [],
        viewType: 'list',
        loggedInAs: false,
        userIsAnonymous: true,
        currentUser: undefined,
        loadingAdditionalListings: false,
        inListView: true,
        showFilterForm: true,
        selectedSort: '',
        sortListings: false,
        showMoreBtn: true,
        filterTags: [],
        showFilterTags: false,
        somethingIsBroken: false,
        selectedImageIdx: 0
      }
    },
    computed: {
      placeholder() {
        return require('../assets/placeholder.png')
      },
    },
    created() {
      if(this.$route.query.autoq === 'true'){
        var muni = this.$route.query.muni
        if (muni === "Any") muni = ""
        var filter={
          muni:muni,
          priceFrom:this.$route.query.priceFrom,
          priceTo:this.$route.query.priceTo,
          bedroomsFrom:this.$route.query.bedroomsFrom,
          bedroomsTo:this.$route.query.bedroomsTo
        }
        this.populateFilterForm(filter)
        this.filterListings()
      }
    },
    mounted() {
      checkForLoginOrGoAnonymous()
        .then(user => {
          this.currentUser = user
          this.loggedInAs = true
          this.userIsAnonymous = user.isAnonymous
          this.getInitialDefaultListings()
        })
        .catch(err => {
          this.somethingIsBroken = true
        })
    },
    methods: {
      getListingCoverImage(listing){
        var comverImg = getListingCoverImage(listing);
        return comverImg
      },
      populateFilterForm(filter){
        this.selectedPlace = filter.muni
        this.filterPriceFrom = filter.priceFrom
        this.filterPriceTo = filter.priceTo
        this.filterBedroomsMin = filter.bedroomsFrom
        this.filterBedroomsMax = filter.bedroomsTo
      },
      getListingCoverThumbnail(listing){
        return getListingCoverThumbnail(listing)
        // for (var i = 0, len = listing.marketingDet.images.length; i < len; i++) {
        //   var image = listing.marketingDet.images[i]
        //   // return thumbnail url not the full img url
        //   if(image.cover == true) return listing.genDet.thumbUrls[i]
        // }
        // return require('../assets/placeholder.png')
      },
      nextPreviewImg(event, payload){
        var thumbUrls = payload.thumbUrls
        var imgHolderId = payload.id
        if(this.selectedImageIdx >= thumbUrls.length-1)this.selectedImageIdx=0
        else this.selectedImageIdx =this.selectedImageIdx + 1

        document.getElementById(imgHolderId).src= thumbUrls[this.selectedImageIdx]
      },
      prevPreviewImg(event, payload){
        var thumbUrls = payload.thumbUrls
        var imgHolderId = payload.id
        if(this.selectedImageIdx >= thumbUrls.length-1)this.selectedImageIdx=0
        else if(this.selectedImageIdx > 0) this.selectedImageIdx = this.selectedImageIdx -1
        else this.selectedImageIdx = thumbUrls.length-1

        document.getElementById(imgHolderId).src= thumbUrls[this.selectedImageIdx]
      },
      getCurrencySign(currency){
        if (currency == 'eur') return '€'
        else if (currency == 'usd') return '$'
        else return ''
      },
      getTxnDisplayType(txnType){
        if(txnType == 'sale') return 'sale'
        else return 'rent'
      },
      getTxnPeriodType(txnType){
        if(txnType == 'rent') return '/ month'
        else if(txnType =='rentShortTerm') return '/ night'
      },
      getPlacePredictions(searchTerm){
        try{
          let searhTermForUrl = searchTerm.replace(new RegExp(' ', 'g'), '+');
          this.placesPredictions = getPlacePredictions(searhTermForUrl, '(cities)')
            .then(predictions => {
              return predictions
            })
            .catch(err => {
              return []
            })
        }catch(error){}
      },
      getMunicipality(googPrediction){
        this.selectedPlace = googPrediction.description
        this.placeId = googPrediction.place_id
        try{
          this.filterMuni = googPrediction.structured_formatting.main_text
        }catch(err){
          this.filterMuni = ''
        }
      },
      getInitialDefaultListings(){
        this.loadingListings = true
        let howManyListingsByDefault = 10
        var currentUnix = (new Date).getTime()
        let filter = this.createFilterFromUserSelection()
        getMaaklerListingsLiteOlderThen(currentUnix, howManyListingsByDefault, filter)
          .then(listings => {
            this.filteredListings = listings
            this.sortedListings = listings
            this.loadingListings = false
          })
          .catch(err => {
            this.filteredListings = []
            this.loadingListings = false
          })
      },
      getAdditionalListingsGate(){
        var lastListingUnix = (new Date).getTime()/1000
        let howManyAdditional = 10

        if(this.filteredListings.length > 0) {
          var lastListing = this.filteredListings[this.filteredListings.length-1]
          lastListingUnix = Date.parse(lastListing.creationDet.createdDate)/1000
        }
        this.getAdditionalListings(lastListingUnix, howManyAdditional)

      },
      getAdditionalListings(olderThanUnix, howMany){
        this.loadingAdditionalListings = true
        let filter = this.createFilterFromUserSelection()
        getMaaklerListingsLiteOlderThen(olderThanUnix, howMany, filter)
          .then(listings => {
            if(listings.length > 0){
              this.filteredListings = this.filteredListings.concat(listings)
              this.sortedListings = this.sortedListings.concat(listings)
              if(this.sortListings) this.startSortListings()
            }else{
              this.showMoreBtn = false
            }
            this.loadingAdditionalListings = false
          })
          .catch(err => {
            this.loadingAdditionalListings = false
          })
      },
      clearFilterAndSearch(){
        this.selectedPlace = undefined
        this.filterMuni = undefined
        this.filterPriceFrom = undefined
        this.filterPriceTo = undefined
        this.filterBedroomsMin = undefined
        this.filterBedroomsMax = undefined
        this.clearFilterTags()
        this.getInitialDefaultListings()
      },
      setFilterTags(filter){
        this.filterTags = []
        for (var key in filter) {
          if(filter[key]) this.filterTags.push(filter[key]);
        }
        if(this.filterTags) this.showFilterTags = true
        else this.showFilterTags = false
      },
      clearFilterTags(){
        this.filterTags = []
        this.showFilterTags = false
      },
      filterListings(){
        this.loadingListings = true
        if(this.currentUser) {
          let f = this.createFilterFromUserSelection()
          let t =(new Date).getTime()
          this.setFilterTags(f)
          getMaaklerListingsLiteOlderThen(t, 20, f)
            .then(listings => {
              this.filteredListings = listings
              this.sortedListings = listings
              if(listings.length > 0 && this.sortListings) this.startSortListings()
              else this.showMoreBtn = false
              this.loadingListings = false
              this.showClearBtn = true
            })
            .catch(err =>{
              this.loadingListings = false
            })
        }else{
          this.loadingListings = false
        }
        this.showMoreBtn = true
      },
      startSortListings(){
        this.sortListings = true
        switch (this.selectedSort) {
          case 'none':
            this.sortListings = false
            this.sortedListings = this.filteredListings
            break;
          case 'price-hf':
            this.sortedListings.sort((listing1, listing2) => {
              return listing1.txnDet.price < listing2.txnDet.price;
            });
            break;
          case 'price-lf':
            this.sortedListings.sort((listing1, listing2) => {
              return listing1.txnDet.price > listing2.txnDet.price;
            });
            break;
          case 'rooms-hf':
            this.sortedListings.sort((listing1, listing2) => {
              return listing1.techDet.nrOfBedrooms < listing2.techDet.nrOfBedrooms;
            });
            break;
          case 'rooms-lf':
            this.sortedListings.sort((listing1, listing2) => {
              return listing1.techDet.nrOfBedrooms > listing2.techDet.nrOfBedrooms;
            });
            break;
          case 'date-hf':
            this.sortedListings.sort((listing1, listing2) => {
              return listing1.creationDet.createdDate < listing2.creationDet.createdDate;
            });
            break;
          case 'date-lf':
            this.sortedListings.sort((listing1, listing2) => {
              return listing1.creationDet.createdDate > listing2.creationDet.createdDate;
            });
            break;
          default:
        }
      },
      createFilterFromUserSelection(){
        return {
          municipality: this.filterMuni,
          priceFromInc: this.filterPriceFrom,
          priceToInc: this.filterPriceTo,
          bedroomsMinInc: this.filterBedroomsMin,
          bedroomsMaxInc: this.filterBedroomsMax
        }
      },
      toggleFilterForm(){
        if(this.showFilterForm) this.showFilterForm = false
        else this.showFilterForm = true
      },
      switchToListView(){
        this.inListView = true
      },
      switchToGridView(){
        this.inListView = false
      },
      navigateToListings(event, listingsId){
        window.open("/#/listing/"+listingsId, "_blank")
        // this.$router.push({
        //   name: 'listing',
        //   params: {
        //     listingId: listingsId
        //   }
        // })
      },
      leavePage(from, to){
        this.$store.dispatch('visitPage', from);
        this.$router.push({
          name: to
        })
      },
      notifyError(title, msg){
        this.$notify({
          title: title,
          message: msg
        })
      },
    }
  }

</script>

<style scoped>
  @import '../assets/styles/global.css';
  @import '../assets/styles/listings-view.css';
  @import '../assets/styles/portal.css';
/*
  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  } */

  .md-chip{
    background-color: #0069d94d;
  }
  .md-autocomplete {
    background-color: white;
    opacity: 1;
  }

  .md-menu-content.md-select-menu{
    background-color: white !important;
  }
  .md-menu-content.md-autocomplete-box-content{
    background-color: white !important;
  }

  .mo-listing-card {
    margin: 4px;
    display: inline-block;
    vertical-align: top;
    width: 32.5%;
  }

  .sort-menu{
    max-width: 300px;
  }

  /*  from infinity to max 700 and then this kicks in*/
  @media (max-width: 1200px) {
   .mo-listing-card{
     width: 49%;
   }
  }
  /*  from infinity to max 700 and then this kicks in*/
  @media (max-width: 700px) {
   .mo-listing-card{
     width: 100%;
   }

   #result-title{
     display: none;
   }

   .sort-menu{
     max-width: 100px;
   }
  }


</style>



// WEBPACK FOOTER //
// src/components/embedMarket.vue